import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.research.list');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ResearchImportState } from "src/libs/research-import";

@Component({
    selector: 'wiz-portal-gsdcuser-research-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.research.list/view.scss */
/* src/app/portal.gsdcuser.research.list/view.scss: no such file or directory */`],
})
export class PortalGsdcuserResearchListComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public researchs: any = [];
    public loaded = false;
    public loading = false;
    public loadError = false;
    public pagination: any = { page: 1, end: 1, start: 1 };
    public searchTerm = '';
    public sort = 'uploaded';
    public total = 0;
    public jumpPage: any = 1;
    public importState = new ResearchImportState(this.service, params => wiz.call('excel', params), async () => {
        await this.load();
        if (this.loadError) throw new Error('RESEARCH_LIST_UNAVAILABLE');
    });
    private readonly pageSize = 5;
    private requestVersion = 0;
    private searchTimer: any;
    private stateKey = '';
    private retryPage = 1;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, '/login');
        const session = this.service.auth.session;
        this.stateKey = 'gsdc.research.list.' + session.id + '.' + session.community_id;
        let state: any = {};
        try { state = JSON.parse(sessionStorage.getItem(this.stateKey) || '{}') || {}; } catch (_) { }
        this.searchTerm = typeof state.text === 'string' ? state.text : '';
        this.sort = ['uploaded', 'published', 'title'].includes(state.sort) ? state.sort : 'uploaded';
        const page = Number(state.page);
        await this.load(Number.isSafeInteger(page) && page > 0 ? page : 1);
    }

    public ngOnDestroy() {
        this.importState.dispose();
        clearTimeout(this.searchTimer);
        this.requestVersion++;
    }

    public get rangeStart() { return this.total && this.researchs.length ? (this.pagination.page - 1) * this.pageSize + 1 : 0; }
    public get rangeEnd() { return this.rangeStart ? this.rangeStart + this.researchs.length - 1 : 0; }
    public get visiblePages() {
        const end = Math.max(1, this.pagination.end);
        const start = Math.max(1, Math.min(this.pagination.page - 2, end - 4));
        return Array.from({ length: Math.min(5, end - start + 1) }, (_, i) => start + i);
    }

    public async load(page = this.pagination.page, scroll = false) {
        clearTimeout(this.searchTimer);
        const version = ++this.requestVersion;
        const text = this.searchTerm;
        const sort = this.sort;
        this.retryPage = page;
        this.loading = true;
        this.loadError = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('search', { text, page, sort });
            if (version !== this.requestVersion) return;
            if (code !== 200 || !Array.isArray(data?.rows)) throw new Error('RESEARCH_LIST_UNAVAILABLE');
            const last = Math.max(1, Number(data.lastpage) || 1);
            if (Number.isSafeInteger(data.page) && data.page > 0) page = data.page;
            // A saved page may no longer exist after records are removed.
            if (page > last) return await this.load(last, scroll);
            this.researchs = data.rows;
            this.total = data.total;
            this.pagination = { page, start: Math.floor((page - 1) / 10) * 10 + 1, end: last };
            this.jumpPage = page;
            this.loaded = true;
            try { sessionStorage.setItem(this.stateKey, JSON.stringify({ text, page, sort })); } catch (_) { }
        } catch (_) {
            if (version !== this.requestVersion) return;
            this.loadError = true;
        } finally {
            if (version === this.requestVersion) {
                this.loading = false;
                await this.service.render();
                if (scroll && !this.loadError) {
                    const heading = document.getElementById('research-results-title');
                    heading?.focus({ preventScroll: true });
                    document.getElementById('research-results')?.scrollIntoView({ block: 'start', behavior: 'auto' });
                }
            }
        }
    }

    public searchChanged() {
        clearTimeout(this.searchTimer);
        this.requestVersion++; // Invalidate in-flight results before the debounce expires.
        this.loading = true;
        this.loadError = false;
        this.searchTimer = setTimeout(() => this.load(1), 300);
    }

    public async clearSearch() {
        this.searchTerm = '';
        document.getElementById('research-search')?.focus();
        await this.load(1);
    }

    public async pageLoad(page: number) {
        if (this.loading) return;
        page = Math.max(1, Math.min(this.pagination.end, Number(page)));
        if (!Number.isSafeInteger(page)) { this.jumpPage = this.pagination.page; return; }
        await this.load(page, true);
    }

    public async retry() { await this.load(this.retryPage); }

}

export default PortalGsdcuserResearchListComponent;